import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { Applications, Server } from '../../clients/aasServerClient.generated';
import { getApplicationName } from '../../stores/applications/selectors';
import { deleteServers } from '../../stores/servers/actionCreators';
import { RootState } from '../../stores/store';
import { select, unselect } from '../../stores/tables/actionCreators';
import { isSelected } from '../../stores/tables/selectors';
import { getUserName } from '../../stores/users/selectors';
import { getWorkspaceName } from '../../stores/workspaces/selectors';
import ConfirmModal from '../common/modals/ConfirmModal';
import MaintenanceIndicator from '../applications/MaintenanceIndicator';
import { getMaintenanceMode } from '../../repositories/ServerRepository';
import { canEditServersPage } from '../../stores/auth/selectors';

interface Props extends LocalizeContextProps, RouteComponentProps {
    server: Server;
    selected: boolean;
    getApplicationName: (id: string) => string;
    canEdit: boolean;

    select: (id: string) => void;
    unselect: (id: string) => void;
    delete: (id: string) => void;
}

interface State {
    showDelete: boolean;
    maintenanceMode?: boolean;
}

class ServersTableRow extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            showDelete: false,
            maintenanceMode: undefined
        };
    }

    private static MMdictionary: any = {}
    private updatingMM = false;
    private async updateMaintenanceMode(){
        this.updatingMM = true;
        var mode = undefined;
        if (this.props.server.maintenanceMode === undefined &&
            ServersTableRow.MMdictionary[this.props.server.id] !== undefined) {
            mode = ServersTableRow.MMdictionary[this.props.server.id];
        } else {
            try {
                mode = await getMaintenanceMode(this.props.server.hostname);
            }
            catch{ 
                mode = null;
            }
            ServersTableRow.MMdictionary[this.props.server.id] = mode;
        }
        this.props.server.maintenanceMode = mode;
        this.setState({ maintenanceMode: mode }, () => { this.updatingMM = false; })
    }

    public render() {
        const t = this.props.translate;
        const server = this.props.server;

        if (!this.updatingMM && (server.maintenanceMode === undefined ||
            this.state.maintenanceMode === undefined || server.maintenanceMode != this.state.maintenanceMode)) {
                this.updateMaintenanceMode();
            }
        return (
            <tr
                className={classnames('table-row', this.props.selected ? 'selected' : '')}
                onClick={(e) => {
                    this.props.selected ?
                        this.props.unselect(server.id) : this.props.select(server.id);
                }}
            >
                <td ><Input type="checkbox" checked={this.props.selected} onChange={() => null} /></td>
                <td onClick={this.updateMaintenanceMode.bind(this)}>
                    <MaintenanceIndicator maintenanceMode={this.state.maintenanceMode}/></td>
                <td>{server.hostname}</td>
                <td>
                    <FontAwesomeIcon icon={server.secure ? ['fal', 'check'] : ['fal', 'times']} />
                </td>
                <td>{server.atp_url}</td>
                <td>{server.anagoVersion}</td>
                <td>{this.getApplicationCell(server.applications)}</td>
                <td className="icon-btn-td">
                    <Button
                        color="success"
                        onClick={() => window.open("https://" + server.hostname + (server.bbm_port ?? ":15933"))}
                    >
                        <FontAwesomeIcon icon={['fas', 'tools']} className="noMarginRight" />
                    </Button>
                </td>
                {this.props.canEdit ?
                <td className="icon-btn-td">
                    <Button
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.history.push('/servers/edit/' + this.props.server.id);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'pencil']} className="noMarginRight" />
                    </Button>
                </td>
                : null}
                {this.props.canEdit ?
                <td className="icon-btn-td">
                    <Button
                        color="danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showDelete: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} className="noMarginRight" />
                    </Button>
                    <ConfirmModal
                        header={t('servers.modal.delete.header') as string}
                        confirmText={t('servers.modal.delete.delete') as string}
                        isOpen={this.state.showDelete}
                        buttonColor="danger"
                        cancel={() => this.setState({ showDelete: false })}
                        confirm={() => this.props.delete(this.props.server.id)}
                    >
                        {`${t('servers.modal.delete.text')} ${this.props.server.hostname || this.props.server.id}`}
                    </ConfirmModal>
                </td>
                : null}
            </tr>
        );
    }

    private getApplicationCell = (applications: Applications[] | undefined) => {
        if (applications === undefined || applications.length === 0) {
            return '';
        } else if (applications.length > 1) {
            return this.props.translate('servers.table.cells.assigned', { number: applications.length });
        } else {
            return this.props.getApplicationName(applications[0].id);
        }
    }
}

const mapStateToProps = (state: RootState, props: { server: Server }) => ({
    getApplicationName: getApplicationName(state),
    selected: isSelected(state, 'servers', props.server.id),
    canEdit: canEditServersPage(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    delete: (id: string) => dispatch(deleteServers([id])),
    select: (id: string) => dispatch(select('servers', id)),
    unselect: (id: string) => dispatch(unselect('servers', id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(ServersTableRow)));